export default __webpack_public_path__ + "./images/sn.8799af52.png";